import styled from '@emotion/styled'

import media from './../../../common/MediaQueries'

export const PlatformsListStyled = styled.ul`
  @media ${media.phone} {
    display: flex;
    justify-content: space-between;
    width: calc(100% + 2rem);
    margin-left: -1rem;
    max-width: 40.625rem;
  }
`

export const PlatformsListItemStyled = styled.li`
  &:not(:first-of-type) {
    margin-top: 2.5rem;
  }

  @media ${media.phone} {
    padding: 0 1rem;
    &:not(:first-of-type) {
      margin-top: 0;
    }
  }
`
